import { create } from 'zustand';
import { persist } from '../../node_modules/zustand/esm/middleware.js';
import { delayedTrackZustand } from '@fabric-app/compat/capabilities/openreplay';

const useInviteStore = create()(delayedTrackZustand(persist((set) => ({
  invite: null,
  setInvite: (invite) => set({
    invite
  })
}), {
  name: "invite",
  version: 2
}), "invite"));

export { useInviteStore as default };
//# sourceMappingURL=invite.js.map
